import React from 'react';
import LearningSection from '../components/LearningSection';

const LearningPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <LearningSection />
    </div>
  );
};

export default LearningPage;

